import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { SearchIcon, PlusIcon, PlusIconWhite } from 'Stories/Icon/Icon.stories'
import { WhiteGreyBtn } from 'Stories/Button/Button.stories'
import { ActionsBlockProps } from './ActionsBlockProps'

import {
  RoundBtn,
  TableHeader,
  StyledInput,
  InputWrapper,
  SearchIconWrapper,
  BtnWithPlus,
} from './styles'

const ActionsBlock: FunctionComponent<ActionsBlockProps> = ({
  approvedListLenght,
  checkAccessToken,
  activeSearch,
  setActiveSearch,
  handleFindCampaign,
}) => {
  const { t } = useTranslation()

  return (
    <TableHeader>
      <Desktop>
        <BtnWithPlus
          approvedListLenght={approvedListLenght > 0}
          onClick={checkAccessToken}
        >
          {approvedListLenght > 0 ? <PlusIcon /> : <PlusIconWhite />}
          {t('campaignsPage.createNewCampaign')}
        </BtnWithPlus>
      </Desktop>

      <Mobile>
        {activeSearch ? (
          <RoundBtn
            onClick={() => {
              setActiveSearch(false)
            }}
          >
            <PlusIcon />
          </RoundBtn>
        ) : (
          <BtnWithPlus
            approvedListLenght={approvedListLenght > 0}
            onClick={checkAccessToken}
          >
            {approvedListLenght > 0 ? <PlusIcon /> : <PlusIconWhite />}
            {t('campaignsPage.createNewCampaign')}
          </BtnWithPlus>
        )}
      </Mobile>

      <InputWrapper
        activeSearch={activeSearch}
        onClick={() => setActiveSearch(true)}
      >
        <StyledInput
          placeholder={t('campaignsPage.searchCampaign')}
          onChange={e => handleFindCampaign(e.target.value)}
          onFocus={() => setActiveSearch(true)}
          onBlur={() => setActiveSearch(false)}
        />
        {!activeSearch && (
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
        )}
      </InputWrapper>
    </TableHeader>
  )
}

export default ActionsBlock
